import { ChangeDetectionStrategy, Component } from '@angular/core';

import { NoDataToDisplayComponent } from '@connect-services/client/components/no-data-to-display/no-data-to-display.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NoDataToDisplayComponent, RessourcesModule],
    selector: 'app-no-permission',
    templateUrl: './management-no-permission.component.html',
})
export class ManagementNoPermissionComponent {}
